/**
 * Get and render next press cards
 * @param {Element} target Observed press card
 * @returns {Object} - promise value for async call
 */
function renderNextPressCards(target) {
    var url = target.getAttribute('data-action');
    var ppid = target.getAttribute('data-next-ppid');

    if (url && ppid) {
        return $.ajax({
            url: url,
            type: 'post',
            data: { lastPressPageID: ppid },
            success: function (response) {
                $('.press-grid').append(response);
            }
        });
    }

    return false;
}

/**
 * Observe last press grid item to load the next prest news
 */
function createPressObserver() {
    var pressGridContainer = document.getElementById('press-grid');

    if (pressGridContainer) {
        var observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    $.when(renderNextPressCards(entry.target)).then(function () {
                        var observableElement = pressGridContainer.lastElementChild;
                        observer.observe(observableElement);
                        observer.unobserve(entry.target);
                    });
                }
            });
        }, { threshold: 0 });

        observer.observe(pressGridContainer.lastElementChild);
    }
}

$(document).ready(function () {
    createPressObserver();
});
